import { createContext } from "react";

import type { AuthInterface } from "./types";

export const AuthContext = createContext<AuthInterface | undefined>(undefined);
